<template>
<cabecera />
  <Menuppal />
  <padre />
  <pie />
</template>

<script>
import Cabecera from './components/Cabecera.vue'
import Menuppal from './components/Menuppal.vue'
import Padre from './components/Padre.vue'
import Pie from './components/Pie.vue'

export default {
  name: 'App',
  //metaInfo: {
  //    title:"Esteban Arroyo | Portafolio",
  //    meta: [
  //      {name: 'description', content:'pagina personal de Esteban Arroyo donde presenta su portafolio de productos y servicios'},
  //      {name:'keywords', content:'professional, Portfolio, portafolio, web-developer, desarrolador, vue, java, python'},
  //      {name:'author',  content:'Esteban Arroyo'},
  //      {name:'copyright', content:'Esteban Arroyo'},
  //      {name:'robots', content:'index'}]
  //  
  //},
  components: {
    Cabecera,
    Menuppal,
    Pie,
    Padre
  }

}
</script>

<style>

</style>
